<template>
  <div v-redirect-if-no-permission:PRICE_RULES>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreatePriceRules' }">
        <v-btn v-if="this.$store.state.user.roles[0].name != 'Call center'" color="primary">{{ $t("settings.priceRules.newPriceRules") }}</v-btn>
      </router-link>
    </v-layout>
    <data-table
      ref="priceRulesDataTable"
      :url="api.ACTIONS.PRICE_RULES"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      perPage="25"
      :fields-hidden-main="[
        'price_rule_id',
        'pick_up_location_cluster_id',
        'price_per_minute',
        'updated_at',
        'created_at',
        'pull_down_cluster',
        'pull_down_location_cluster_id',
      ]"
      :titles="titles"
      :actions-extra-main="actionsExtraMain"
      :disable-search="false"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Price_Rules",
  title() {
    return this.$t("settings.priceRules.title");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
    };
  },
  computed: {
    titles() {
      return {
        id: this.$t("settings.priceRules.id"),
        pull_down_location_cluster_title: this.$t("settings.priceRules.pullDownCluster"),
        max_price: this.$t("settings.priceRules.maxPrice"),
        min_price: this.$t("settings.priceRules.minPrice"),
        event_max_price: this.$t("settings.priceRules.eventsMaxPrice"),
        event_min_price: this.$t("settings.priceRules.eventsMinPrice"),
        min_time: this.$t("settings.priceRules.minTime"),
      };
    },
    actionsExtraMain() {
      if (this.$store.state.user.roles[0].name == 'Call center') return {};  
      return {
        editPriceRules: {
          title: this.$t("settings.priceRules.editPriceRule"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditPriceRules",
              params: { id: item.id },
            }),
        },
        deletePriceRules: {
          title: this.$t("settings.priceRules.deletePriceRule"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.$dialova({
              title: this.$t("settings.priceRules.deletingItem", { id }),
              paragraph: this.$t("settings.priceRules.confirmDelete", { id }),
              loader: true,
            })
              .then(({ close }) => {

                this.loading = true;
                  this.axios
                    .delete(`priceRule/${id}`)
                    .then((res) => {
                      window.getApp.$emit(
                        "SHOW_TOAST",
                        this.$t("settings.priceRules.deletedSuccessfully"),
                        "green"
                      );
                      this.$refs.priceRulesDataTable.getData();
                    })
                    .catch((err) => {
                      let response = err.response;
                      if (response) {
                        window.getApp.$emit(
                          "SHOW_TOAST",
                          response.data.message,
                          "red"
                        );
                      } else {
                        window.getApp.$emit(
                          "SHOW_TOAST",
                          this.$t("settings.priceRules.somethingWentWrong"),
                          "red"
                        );
                      }
                    })
                    .finally(() => {
                      this.loading = false
                    close();
                    });
              })
              .catch(() => {
                console.log("cancelled");
              });
          },
        },
      };
    },
  },
};
</script>
